<img class="fill"
  [image]="mainImage"
  [attr.alt]="altText">

@if (canPrintAltImage()) {
  <img class="fill alt-image"
    [image]="altImage"
    [attr.alt]="altText"
    >
}